import LoginForm from "./LoginForm";
import loginIllustration from "../assets/images/login-illustration.svg";

function LoginPage({ onLogin }) {
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="image-section">
          <div className="image-content">
            <img
              src={loginIllustration}
              alt="Login illustration"
              className="login-image"
            />
            <div className="carousel-indicators">
              <svg
                width="89"
                height="16"
                viewBox="0 0 89 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8.5" cy="8" r="8" fill="#4285F3"></circle>
                <circle cx="32.5" cy="8" r="8" fill="#C6DCFF"></circle>
                <circle cx="56.5" cy="8" r="8" fill="#C6DCFF"></circle>
                <circle cx="80.5" cy="8" r="8" fill="#C6DCFF"></circle>
              </svg>
            </div>
          </div>
        </div>
        <div className="form-section">
          <div className="form-container">
            <LoginForm onLogin={onLogin} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
